var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _circle, _rect3, _rect4, _circle2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.7506 43.7916C79.9561 43.2906 80.6655 43.2906 80.8709 43.7916L81.8609 46.2053C81.9479 46.4173 82.1471 46.5621 82.3756 46.5793L84.9771 46.7749C85.517 46.8155 85.7363 47.4902 85.3233 47.8404L83.3337 49.5278C83.1589 49.676 83.0828 49.9103 83.137 50.1329L83.7549 52.6676C83.8831 53.1936 83.3092 53.6106 82.8485 53.3261L80.6289 51.9552C80.4339 51.8348 80.1876 51.8348 79.9926 51.9552L77.773 53.3261C77.3123 53.6106 76.7384 53.1936 76.8666 52.6676L77.4845 50.1329C77.5387 49.9103 77.4626 49.676 77.2878 49.5278L75.2982 47.8404C74.8853 47.4902 75.1045 46.8155 75.6444 46.7749L78.2459 46.5793C78.4744 46.5621 78.6737 46.4173 78.7606 46.2053L79.7506 43.7916Z",
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5099 43.7916C92.7153 43.2906 93.4247 43.2906 93.6302 43.7916L94.6202 46.2053C94.7071 46.4173 94.9064 46.5621 95.1349 46.5793L97.7364 46.7749C98.2763 46.8155 98.4955 47.4902 98.0826 47.8404L96.0929 49.5278C95.9182 49.676 95.842 49.9103 95.8963 50.1329L96.5142 52.6676C96.6424 53.1936 96.0685 53.6106 95.6078 53.3261L93.3882 51.9552C93.1932 51.8348 92.9469 51.8348 92.7519 51.9552L90.5323 53.3261C90.0716 53.6106 89.4977 53.1936 89.6259 52.6676L90.2437 50.1329C90.298 49.9103 90.2219 49.676 90.0471 49.5278L88.0575 47.8404C87.6445 47.4902 87.8637 46.8155 88.4037 46.7749L91.0052 46.5793C91.2337 46.5621 91.4329 46.4173 91.5199 46.2053L92.5099 43.7916Z",
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.262 43.7916C105.468 43.2906 106.177 43.2906 106.383 43.7916L107.373 46.2053C107.46 46.4173 107.659 46.5621 107.887 46.5793L110.489 46.7749C111.029 46.8155 111.248 47.4902 110.835 47.8404L108.845 49.5278C108.671 49.676 108.594 49.9103 108.649 50.1329L109.267 52.6676C109.395 53.1936 108.821 53.6106 108.36 53.3261L106.141 51.9552C105.946 51.8348 105.699 51.8348 105.504 51.9552L103.285 53.3261C102.824 53.6106 102.25 53.1936 102.378 52.6676L102.996 50.1329C103.05 49.9103 102.974 49.676 102.8 49.5278L100.81 47.8404C100.397 47.4902 100.616 46.8155 101.156 46.7749L103.758 46.5793C103.986 46.5621 104.185 46.4173 104.272 46.2053L105.262 43.7916Z",
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.016 43.7916C118.221 43.2906 118.931 43.2906 119.136 43.7916L120.126 46.2053C120.213 46.4173 120.412 46.5621 120.641 46.5793L123.242 46.7749C123.782 46.8155 124.001 47.4902 123.588 47.8404L121.599 49.5278C121.424 49.676 121.348 49.9103 121.402 50.1329L122.02 52.6676C122.148 53.1936 121.574 53.6106 121.114 53.3261L118.894 51.9552C118.699 51.8348 118.453 51.8348 118.258 51.9552L116.038 53.3261C115.577 53.6106 115.004 53.1936 115.132 52.6676L115.75 50.1329C115.804 49.9103 115.728 49.676 115.553 49.5278L113.563 47.8404C113.15 47.4902 113.37 46.8155 113.91 46.7749L116.511 46.5793C116.74 46.5621 116.939 46.4173 117.026 46.2053L118.016 43.7916Z",
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.768 43.7916C130.974 43.2906 131.683 43.2906 131.888 43.7916L132.878 46.2053C132.965 46.4173 133.165 46.5621 133.393 46.5793L135.995 46.7749C136.535 46.8155 136.754 47.4902 136.341 47.8404L134.351 49.5278C134.176 49.676 134.1 49.9103 134.155 50.1329L134.772 52.6676C134.901 53.1936 134.327 53.6106 133.866 53.3261L131.646 51.9552C131.451 51.8348 131.205 51.8348 131.01 51.9552L128.791 53.3261C128.33 53.6106 127.756 53.1936 127.884 52.6676L128.502 50.1329C128.556 49.9103 128.48 49.676 128.305 49.5278L126.316 47.8404C125.903 47.4902 126.122 46.8155 126.662 46.7749L129.263 46.5793C129.492 46.5621 129.691 46.4173 129.778 46.2053L130.768 43.7916Z",
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.8564,
    y: 80.9805,
    width: 101.587,
    height: 9.63966,
    rx: 1.23214,
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.8564,
    y: 94.2812,
    width: 59.7142,
    height: 9.42857,
    rx: 1.23214,
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.9008,
    cy: 68.0092,
    r: 7.04437,
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9111,
    y: 63.1914,
    width: 32.6266,
    height: 4.44908,
    rx: 2.22454,
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9111,
    y: 69.125,
    width: 13.3472,
    height: 4.44908,
    rx: 2.22454,
    fill: "#CDD0EA",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.136,
    cy: 72.6668,
    r: 46.7615,
    transform: "rotate(43.3823 73.136 72.6668)",
    fill: "#CDD0EA",
    fillOpacity: 0.28
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8105 111.356C57.4722 129.937 87.8116 130.199 107.764 112.736L133.963 137.496C135.554 139 138.064 138.929 139.568 137.337C141.072 135.746 141.002 133.236 139.41 131.732L113.322 107.077C131.003 86.1419 129.441 54.7888 109.278 35.7338C88.3958 15.9986 55.4687 16.9285 35.7335 37.8109C15.9982 58.6933 16.9282 91.6204 37.8105 111.356ZM42.4925 106.399C60.6393 123.549 89.2529 122.741 106.403 104.594C123.553 86.447 122.745 57.8333 104.598 40.6834C86.4511 23.5334 57.8374 24.3416 40.6875 42.4884C23.5376 60.6352 24.3457 89.2488 42.4925 106.399Z",
    fill: "#BEC1D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2610b76876c982c06866e57eed82bc7a.svg";
export { ForwardRef as ReactComponent };